// User and Organization Enums
export var UserRole;
(function (UserRole) {
    UserRole["OWNER"] = "owner";
    UserRole["ADMIN"] = "admin";
    UserRole["MEMBER"] = "member";
    UserRole["VIEWER"] = "viewer";
})(UserRole || (UserRole = {}));
// Project Enums
export var ProjectStatus;
(function (ProjectStatus) {
    ProjectStatus["PLANNING"] = "planning";
    ProjectStatus["ACTIVE"] = "active";
    ProjectStatus["ON_HOLD"] = "on_hold";
    ProjectStatus["COMPLETED"] = "completed";
    ProjectStatus["ARCHIVED"] = "archived";
})(ProjectStatus || (ProjectStatus = {}));
// Sheet Enums
export var SheetType;
(function (SheetType) {
    SheetType["GRID"] = "grid";
    SheetType["GANTT"] = "gantt";
    SheetType["CARD"] = "card";
    SheetType["CALENDAR"] = "calendar";
})(SheetType || (SheetType = {}));
export var ColumnType;
(function (ColumnType) {
    ColumnType["TEXT"] = "text";
    ColumnType["NUMBER"] = "number";
    ColumnType["DATE"] = "date";
    ColumnType["DATETIME"] = "datetime";
    ColumnType["DURATION"] = "duration";
    ColumnType["PERCENT"] = "percent";
    ColumnType["CURRENCY"] = "currency";
    ColumnType["CHECKBOX"] = "checkbox";
    ColumnType["DROPDOWN_SINGLE"] = "dropdown_single";
    ColumnType["DROPDOWN_MULTI"] = "dropdown_multi";
    ColumnType["CONTACT"] = "contact";
    ColumnType["PREDECESSOR"] = "predecessor";
    ColumnType["AUTO_NUMBER"] = "auto_number";
    ColumnType["FORMULA"] = "formula";
    ColumnType["SYMBOL"] = "symbol";
    ColumnType["ATTACHMENT"] = "attachment";
})(ColumnType || (ColumnType = {}));
// Scheduling Enums
export var ConstraintType;
(function (ConstraintType) {
    /** As Soon As Possible */
    ConstraintType["ASAP"] = "asap";
    /** As Late As Possible */
    ConstraintType["ALAP"] = "alap";
    /** Must Start On */
    ConstraintType["MSO"] = "mso";
    /** Must Finish On */
    ConstraintType["MFO"] = "mfo";
    /** Start No Earlier Than */
    ConstraintType["SNET"] = "snet";
    /** Start No Later Than */
    ConstraintType["SNLT"] = "snlt";
    /** Finish No Earlier Than */
    ConstraintType["FNET"] = "fnet";
    /** Finish No Later Than */
    ConstraintType["FNLT"] = "fnlt";
})(ConstraintType || (ConstraintType = {}));
export var TaskType;
(function (TaskType) {
    /** Duration changes when units or work change */
    TaskType["FIXED_UNITS"] = "fixed_units";
    /** Work changes when units or duration change */
    TaskType["FIXED_DURATION"] = "fixed_duration";
    /** Units change when duration or work change */
    TaskType["FIXED_WORK"] = "fixed_work";
})(TaskType || (TaskType = {}));
export var DependencyType;
(function (DependencyType) {
    /** Finish-to-Start: Successor starts after predecessor finishes */
    DependencyType["FS"] = "fs";
    /** Start-to-Start: Successor starts when predecessor starts */
    DependencyType["SS"] = "ss";
    /** Finish-to-Finish: Successor finishes when predecessor finishes */
    DependencyType["FF"] = "ff";
    /** Start-to-Finish: Successor finishes when predecessor starts */
    DependencyType["SF"] = "sf";
})(DependencyType || (DependencyType = {}));
// Automation Enums
export var AutomationTrigger;
(function (AutomationTrigger) {
    AutomationTrigger["ROW_CREATED"] = "row_created";
    AutomationTrigger["ROW_UPDATED"] = "row_updated";
    AutomationTrigger["ROW_DELETED"] = "row_deleted";
    AutomationTrigger["DATE_REACHED"] = "date_reached";
    AutomationTrigger["FORM_SUBMITTED"] = "form_submitted";
    AutomationTrigger["SCHEDULE"] = "schedule";
    AutomationTrigger["COMMENT_ADDED"] = "comment_added";
})(AutomationTrigger || (AutomationTrigger = {}));
export var AutomationAction;
(function (AutomationAction) {
    AutomationAction["SEND_EMAIL"] = "send_email";
    AutomationAction["SEND_NOTIFICATION"] = "send_notification";
    AutomationAction["UPDATE_CELL"] = "update_cell";
    AutomationAction["CREATE_ROW"] = "create_row";
    AutomationAction["MOVE_ROW"] = "move_row";
    AutomationAction["COPY_ROW"] = "copy_row";
    AutomationAction["LOCK_ROW"] = "lock_row";
    AutomationAction["REQUEST_APPROVAL"] = "request_approval";
})(AutomationAction || (AutomationAction = {}));
// Activity Log Enums
export var ActivityType;
(function (ActivityType) {
    ActivityType["TASK_CREATED"] = "task_created";
    ActivityType["TASK_UPDATED"] = "task_updated";
    ActivityType["TASK_DELETED"] = "task_deleted";
    ActivityType["TASK_MOVED"] = "task_moved";
    ActivityType["COMMENT_ADDED"] = "comment_added";
    ActivityType["ATTACHMENT_ADDED"] = "attachment_added";
    ActivityType["MEMBER_ADDED"] = "member_added";
    ActivityType["MEMBER_REMOVED"] = "member_removed";
    ActivityType["PROJECT_CREATED"] = "project_created";
    ActivityType["PROJECT_UPDATED"] = "project_updated";
    ActivityType["BASELINE_CREATED"] = "baseline_created";
})(ActivityType || (ActivityType = {}));
// Notification Enums
export var NotificationType;
(function (NotificationType) {
    NotificationType["MENTION"] = "mention";
    NotificationType["ASSIGNMENT"] = "assignment";
    NotificationType["DUE_DATE"] = "due_date";
    NotificationType["COMMENT"] = "comment";
    NotificationType["APPROVAL_REQUEST"] = "approval_request";
    NotificationType["APPROVAL_RESPONSE"] = "approval_response";
    NotificationType["SHARE"] = "share";
})(NotificationType || (NotificationType = {}));
// Approval Enums
export var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["PENDING"] = "pending";
    ApprovalStatus["APPROVED"] = "approved";
    ApprovalStatus["REJECTED"] = "rejected";
    ApprovalStatus["CANCELLED"] = "cancelled";
})(ApprovalStatus || (ApprovalStatus = {}));
//# sourceMappingURL=enums.js.map